import styled from 'styled-components'

const Link = styled.a``

export default Link
